import { useTranslation } from 'react-i18next';
import { Segmented, Tooltip } from 'ui';
import { useCalendarSettings } from '../../../storages';
import { useGetModeOptions } from './hooks';

const ModeNavigator = () => {
  const [{ mode }, setCalendarSettings] = useCalendarSettings();
  const options = useGetModeOptions();
  const { t } = useTranslation();

  return (
    <Tooltip title="View">
      <Segmented
        aria-label={t('View')}
        onChange={(value) => {
          setCalendarSettings({ mode: value });
        }}
        options={options}
        value={mode}
      />
    </Tooltip>
  );
};

export default ModeNavigator;
